import { AssetReference } from '@opallabs/cassini'

enum AssetOrientations {
  Square = 'square',
  Portrait = 'portrait',
  Landscape = 'landscape',
}

/* getAssetOrientation takes an asset and returns its aspect ratio/orientation based on its height and width */
export default function getAssetOrientation(
  asset: AssetReference
): AssetOrientations {
  if (asset.height && asset.width && asset.height > asset.width)
    return AssetOrientations.Portrait
  if (asset && asset.height === asset.width) return AssetOrientations.Square
  return AssetOrientations.Landscape
}
